<div class="card pb-0 mb-0">
  <div class="flex justify-content-between mb-3">
    <div class="flex flex-column align-items-center gap-2 w-full">
      <div class="align-self-start">
        <span class="block text-primary-600 font-bold mb-3 text-lg">{{
          cardConfig().header
        }}</span>

        <child-kpi-count
          [dataLength]="cardConfig().data | async"
          [entity]="cardConfig().entity"
        ></child-kpi-count>
      </div>
      <button
        pButton
        [routerLink]="cardConfig().route"
        [style.minWidth.rem]="'20'"
        class="text-gray-800 text-xl w-full flex justify-content-center"
        style="background-color: white"
      >
        <span class="text-center"> {{ cardConfig().routeLabel }}</span>
      </button>
    </div>
    <div
      [ngClass]="cardConfig().iconBackgroundColor"
      class="flex align-items-center justify-content-center border-round"
      [ngStyle]="{ width: '2.5rem', height: '2.5rem' }"
    >
      <i
        [ngClass]="[cardConfig().icon, cardConfig().iconColor]"
        class="text-xl"
      ></i>
    </div>
  </div>
</div>
